import React, { useState } from "react";
// redux
import { useSelector, useDispatch } from "react-redux";
import { deleteFound } from "../../redux/actions/FoundActions.js";
import { claim, unClaim } from "../../redux/actions/ClaimActions.js";
//react components for routing our app without refresh
// import { useParams } from "react-router";
import { useParams, Link, useHistory } from "react-router-dom";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { Grid } from "@material-ui/core";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
// other
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/components.js";
import { toast } from "react-toastify";
import { formatDateTime, toastOptions, Transition } from "utils.js";

const useStyles = makeStyles(styles);

export default function FoundDetailPage() {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );

  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const auth = useSelector((state) => state.auth);
  const foundItem = useSelector(
    (state) => state.foundItems.filter((item) => item.id === id)[0]
  );
  const isClaimed = useSelector((state) =>
    state.claimRequests.filter(
      (claim) =>
        claim.foundItemId === id && claim.claimerUsername === auth.user.username
    )
  );
  const [deleteModal, setDeleteModal] = useState(false);

  const handleDelete = () => {
    setDeleteModal(false);
    if (auth.user.username !== foundItem?.username) {
      toast.error(
        "You are not authorized to perform this action!",
        toastOptions
      );
      return;
    }
    deleteFound(dispatch, history, foundItem?.id);
  };

  const handleClaim = () => {
    if (isClaimed.length > 0) {
      toast.warning(
        "Item already claimed. please visit the Lost and Found Department!",
        toastOptions
      );
    } else {
      claim(dispatch, { claimerUsername: auth.user.username, foundItemId: id });
    }
  };

  const handleUnClaim = () => {
    if (isClaimed.length === 0) {
      toast.warning("Item not claimed!", toastOptions);
    } else {
      unClaim(dispatch, {
        claimerUsername: auth.user.username,
        foundItemId: id,
      });
    }
  };

  var renderer = <div></div>;
  if (auth.user.username === foundItem?.username) {
    renderer = (
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={6}>
          <Button onClick={() => setDeleteModal(true)} round color="danger">
            Delete
          </Button>
        </Grid>
      </Grid>
    );
  } else {
    if (isClaimed.length > 0) {
      renderer = (
        <Grid
          container
          spacing={3}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} md={6}>
            <Button onClick={handleUnClaim} round color="warning">
              Undo Claim
            </Button>
          </Grid>
        </Grid>
      );
    } else {
      renderer = (
        <Grid
          container
          spacing={3}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} md={6}>
            <Button onClick={handleClaim} round color="success">
              Claim
            </Button>
          </Grid>
        </Grid>
      );
    }
  }

  return (
    <div>
      <Header
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 200,
          color: "white",
        }}
      />
      <Parallax small filter image={require("assets/img/bg4.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>Found Items</h1>
                <h3 className={classes.subtitle}>
                  The list of found items posted by the users.
                </h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <GridContainer className={classes.container}>
          <GridItem xs={12} md={6} className="my-5">
            <img
              src={foundItem?.imageId}
              alt="founditem"
              width="100%"
              className={imageClasses}
            />
          </GridItem>
          <GridItem xs={12} md={6} className="my-5">
            <Table className="minWidth: 650" aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell align="right">Item Name</TableCell>
                  <TableCell align="left">{foundItem?.itemName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Description</TableCell>
                  <TableCell align="left">{foundItem?.description}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Posted By</TableCell>
                  <TableCell align="left">
                    {" "}
                    <Link to={"/users/" + foundItem?.username}>
                      {foundItem?.username}
                    </Link>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Found Location</TableCell>
                  <TableCell align="left">{foundItem?.location}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Found on</TableCell>
                  <TableCell align="left">
                    {formatDateTime(foundItem?.foundTimestamp)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Posted on</TableCell>
                  <TableCell align="left">
                    {formatDateTime(foundItem?.createdAt)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Updated on</TableCell>
                  <TableCell align="left">
                    {formatDateTime(foundItem?.updatedAt)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>

            <br />
            {renderer}

            <Dialog
              classes={{
                root: classes.center,
                paper: classes.modal,
              }}
              open={deleteModal}
              TransitionComponent={Transition}
              keepMounted
              onClose={() => setDeleteModal(false)}
              aria-labelledby="delete-modal-slide-title"
              aria-describedby="delete-modal-slide-description"
            >
              <DialogTitle
                id="delete-modal-slide-title"
                disableTypography
                className={classes.modalHeader}
              >
                <IconButton
                  className={classes.modalCloseButton}
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  onClick={() => setDeleteModal(false)}
                >
                  <Close className={classes.modalClose} />
                </IconButton>
                <h4 className={classes.modalTitle}>Delete Found Item</h4>
              </DialogTitle>
              <DialogContent
                id="delete-modal-slide-description"
                className={classes.modalBody}
              >
                <p>Are you sure you want to delete this found item?</p>
              </DialogContent>
              <DialogActions className={classes.modalFooter}>
                <Button onClick={handleDelete} color="danger" simple>
                  Yes
                </Button>
                <Button
                  onClick={() => setDeleteModal(false)}
                  color="transparent"
                  simple
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>
          </GridItem>
        </GridContainer>
      </div>
      <Footer />
    </div>
  );
}
